import React, { useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import './profile.css'
import { Helmet } from 'react-helmet'
import { Button, Checkbox, Input, Main, PageHeader, Skeleton } from '../../Components'
import { useSelector } from 'react-redux'

export function Profile() {

    const regex_validator = {
		email : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	}	

	 
	const effectCalled = useRef(false)
	const navigate = useNavigate()
    const { user , org } = useSelector((state) => state.auth)

	const [isLoading, setIsLoading] = useState(false)
	const [isLoadingUserData, setIsLoadingUserData] = useState(false)

	const [formData, setFormData] = useState({
		name: "",
        email : "",
        use_magic_link : true,
        old_password : '',
        new_password : '',
        has_old_password : false,
	});
	const [formValidation, setFormValidation] = useState({
		name : "",
		email : "",
        old_password: "",
        new_password: "",
		 
		 
	})


	useEffect(() => {

		if(effectCalled.current){ return ;}
		 
		async function fetchData() {
			
			await getUser();
		}
		fetchData();

		effectCalled.current = true ;
	  
	}, [])



	/**
	 * 
	 * @returns 
	 */
	const getUser = () => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingUserData(true)
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { }

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/users/me` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

                    //console.log('user : ' , data)

					setFormData( (prevState) => ({ 
						...prevState,
						name: data?.name,
						email: data?.email,
						has_old_password : data?.has_password ,
                        use_magic_link : data?.login_method === 'magic-link' ? true : false ,
					}))

					 
					 

					setIsLoadingUserData(false)
		
					resolve(data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoadingUserData(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingUserData(false)
			}

		})
	} 


	/**
	 * 
	 * @param {*} e 
	 * @returns 
	 */
	const onSubmit = async (e) => {
		e.preventDefault();

		return new Promise( async (resolve, reject) => { 
			
			setIsLoading(true)
			let validationInputs = { 
                name : '' , 
                email : '' , 
                old_password : '' ,
                new_password : '' 
            };
			validationInputs.name = (formData?.name === null  || formData?.name === '' ) ? "Name can't be blank." : '';
			validationInputs.email  = (formData.email.match(regex_validator.email)===null) ? 'Invalid email' : ''
            if(formData?.use_magic_link === false ){

                if(formData?.has_old_password === true ) validationInputs.old_password = (formData?.old_password?.length < 4 ) ? 'Password too short, try a mix of characters and numbers' : ''; 
                validationInputs.new_password = (formData?.new_password?.length < 4 ) 
                    ? 'Password too short, try a mix of characters and numbers'
                    : (formData?.new_password === formData?.old_password
                            ? 'The new password is the same as the old password.'
                            : ''
                        ) ;
            }

			setFormValidation((prevState) => ({
				...prevState,
				name : validationInputs?.name,
                email : validationInputs?.email,
                old_password : validationInputs?.old_password,
                new_password : validationInputs?.new_password,
			}))

			if( validationInputs?.name !=='' || validationInputs?.email !== '' || validationInputs?.old_password !=='' || validationInputs?.new_password !=='' ){
				toast.error("Please complete all required fields") 

				 
				setIsLoading(false)

				return 
			}

			
			
			
			
			
			if (user && user.token && org && org?.id && formData?.id !==null ) {

				
				let params = { 
					name : formData?.name,
					email : formData?.email,
					old_password : formData?.old_password,
					new_password : formData?.new_password,
					use_magic_link : formData?.use_magic_link,
					 
				}
			 

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/users/${user?.id}`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsLoading(false)

					
					toast.success('Your profile has been successfully updated') 
					 

					 
		
					resolve(data.data) 
		
				})
				.catch(error => {
					//console.log(error)
                    let __error = "Something went wrong. thank you try later."
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
                            
						}
                        __error = (typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message;
					} else {
                        // Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
                            __error = `Something went wrong. thank you try later.`
						}
					}
                    
					toast.error(__error) 
                    reject(__error);
				})
			}else{
				setIsLoading(false)
				toast.error('Something went wrong, please try again later.') 
			}


		})

	}

	/**
	 * 
	 * @param {*} e 
	 */
	const onChange = (e) => {

		switch(e.target.name){
            case "email" : 
				setFormValidation((prevState) => ({
					...prevState,
					email : (e.target.value.match(regex_validator.email)===null) ? 'Invalid email address' : ''
				}))
				
				break;
			case "name" : 
				setFormValidation((prevState) => ({
					...prevState,
					name : (e.target.value === '') ? "Name can't be blank." : ''
				}))
				
				break;
            case "old_password":
                const old_password_error = (e.target.value.length < 4 ) ? 'Password too short, try a mix of characters and numbers' : '' 
                setFormValidation((prevState) => ({
					...prevState,
					old_password : old_password_error
				}))
            break;
            case "new_password":
                let new_password_error = "";
                if(e.target.value.length < 4 ) 
                    new_password_error = 'Password too short, try a mix of characters and numbers';
                else if(e.target.value === formData?.old_password){
                    
                    new_password_error = 'The new password is the same as the old password.';
                }
                setFormValidation((prevState) => ({
					...prevState,
					new_password : new_password_error
				}))
            break;
			 
			
		}

		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: (e.target.type ==='checkbox') ? e.target.checked :  e.target.value,
		}));
	};
	 

	return (
		<>
		<Helmet>
			<title>{`Profile - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			breadcrumbsItems={[
				{ name: 'Home', link: '/' },
				{ name: 'Profile', link: `/profile`},
			]}
			 >
				<PageHeader
					title="Profile"
					// description="Give your account a recognisable name, so your team mates can easily switch between accounts."
					/>
				 <form onSubmit={onSubmit}>
					{
						isLoadingUserData === true 
						? <>
							
							<Skeleton className="mb-10" width={40} height={16} radius="sm" />
							<Skeleton className="mb-10" width="60%" height={36} radius="sm" />
							<Skeleton width={100} height={36} radius="sm" />

							<Skeleton className="mb-10" width={40} height={16} radius="sm" />
							<Skeleton className="mb-10" width="60%" height={36} radius="sm" />
							<Skeleton width={100} height={36} radius="sm" />
						</>
						: (
							<>
					
						<Input
							label="Name"
							placeholder=""
							name="name"
							onChange={onChange}
							value={formData?.name}
							required
							// note={organization_id}
							error={formValidation?.name}
							/>
						<Input
							label="Email address"
							placeholder=""
							name="email"
							onChange={onChange}
							value={formData?.email}
							required
							// note={organization_id}
							error={formValidation?.email}
							
							/>
                        <div className="form-separate"></div>
                        <h3>Authentification settings</h3>    
                        <Checkbox
                            name="use_magic_link" 
                            label="Use magic link to login ( without password )"
                            description="By enabling this option, you can log in to your account using a magic link sent to your email, without needing to remember a password. Simply enter your email address and click on the magic link to log in quickly and securely."
                            checked={formData?.use_magic_link}
                            onChange={onChange}
                            // defaultValue={formData?.use_magic_link}
                            />
                        {
                            formData?.use_magic_link === false && 
                            <div className='password-change-wrapper'>
                                {
                                    formData?.has_old_password && 
                                    <Input
                                        type="password"
                                        label="Old password"
                                        placeholder=""
                                        name="old_password"
                                        onChange={onChange}
                                        value={formData?.old_password}
                                        required
                                        // note={organization_id}
                                        error={formValidation?.old_password}
                                        
                                        />
                                }
                                <Input
                                    type="password"
                                    label="New password"
                                    placeholder=""
                                    name="new_password"
                                    onChange={onChange}
                                    value={formData?.new_password}
                                    required
                                    // note={organization_id}
                                    error={formValidation?.new_password}
                                    
                                    />
                            </div>
                        }

						<div className="field-group submit-fields-group fluid form_fixed_footer">
							<div className="container flex-start">
								<Button type="submit"  onClick={onSubmit}  loading={isLoading} >{'Update'}</Button>
							</div>
						</div>

							</>
						)
					}
				</form>	
		 </Main>
		</>
	)
}
